<template>
  <base-form-field :label="label" :vuelidate="vuelidate">
    <div class="ps-mt-1 ps-flex ps-rounded-md ps-shadow-sm">
      <div class="ps-relative ps-flex-grow focus-within:ps-z-10">
        <input
          id="email"
          :value="value"
          class="ps-font-mono ps-form-input ps-block ps-w-full ps-rounded-none ps-rounded-l-md ps-pl-3 ps-transition ps-ease-in-out ps-duration-150 sm:ps-text-sm sm:ps-leading-5"
        />
      </div>
      <button
        class="ps--ml-px ps-relative ps-inline-flex ps-items-center ps-px-4 ps-py-2 ps-border ps-border-gray-300 ps-text-sm ps-leading-5 ps-font-medium ps-rounded-r-md ps-text-gray-700 ps-bg-gray-50 hover:ps-text-gray-500 hover:ps-bg-white focus:ps-outline-none focus:ps-shadow-outline-blue focus:ps-border-blue-300 active:ps-bg-gray-100 active:ps-text-gray-700 ps-transition ps-ease-in-out ps-duration-150"
        ref="clipTrigger"
      >
        <svg-icon
          class="ps-h-5 ps-w-5 ps-text-gray-400 ps-svg-stroke-two"
          name="copy"
          width="20"
          height="auto"
        />
        <span class="ps-ml-2">Copy</span>
      </button>
    </div>
  </base-form-field>
</template>

<script>
import BaseFormField from '@/components/forms/BaseFormField'
import BaseInput from '@/components/inputs/BaseInput'
import ButtonIcon from '@/components/buttons/ButtonIcon'
import ClipboardJS from 'clipboard'

import '@/icons/copy'

export default {
  name: 'CopyLink',
  props: {
    vuelidate: Object,
    label: String,
    value: String
  },
  components: {
    BaseFormField,
    BaseInput,
    ButtonIcon
  },
  mounted() {
    this.initClipboard()
  },
  beforeDestroy() {
    this.clipboard.destroy()
  },
  methods: {
    initClipboard() {
      this.clipboard = new ClipboardJS(this.$refs.clipTrigger, {
        text: this.setClipboard
      })
      this.clipboard.on('success', this.success)

      this.clipboard.on('error', function(e) {
        console.error('Action:', e.action)
        console.error('Trigger:', e.trigger)
      })
    },
    setClipboard(trigger) {
      console.log('set clipboard text', this.value)
      return this.value
    },
    success(e) {
      console.info('Action:', e.action)
      console.info('Text:', e.text)
      console.info('Trigger:', e.trigger)

      e.clearSelection()
    }
  }
}
</script>
